import React from 'react';
import { Button } from '../../../button';
import { Stack } from '../../../stack';
import { ModalActionsProps } from './model';

export * from './model';

export const ModalActions: React.FC<ModalActionsProps> = ({ actions, sx }) => {
  return (
    <Stack direction="row" justifyContent="center" mt={2} px={{ xs: 2.5, md: 0 }} spacing={1} sx={sx}>
      {actions?.map(({ title: actionTitle, callback, color, variant, buttonProps }) => (
        <Button color={color} key={actionTitle} onClick={callback} variant={variant} {...buttonProps}>
          {actionTitle}
        </Button>
      ))}
    </Stack>
  );
};
